































import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";
import { SearchCondition } from "@/types/entities";

@Component({
  components: {},
})
export default class SearchInput extends Vue {
  private optValue = "すべて";
  private searchKeyword = "";

  @Prop()
  private options!: string[];
  @Prop()
  private condition!: SearchCondition;

  private getValidOptions() {
    if (this.$props.options) {
      return this.$props.options.filter((item: any) => item.label !== "");
    } else {
      return [];
    }
  }

  @Emit("changeFilterCondition")
  private handleOnFilterGroup(e: any) {
    return {
      group: e.target.value,
      keyword: this.searchKeyword,
    };
  }

  @Emit("changeFilterCondition")
  private handleOnFilterKeyword() {
    return {
      group: this.optValue,
      keyword: this.searchKeyword,
    };
  }

  @Watch("condition")
  private onConditionChange(val: SearchCondition, oldVal: SearchCondition) {
    this.optValue = val.group;
    this.searchKeyword = val.keyword;
  }
}
